import { render, staticRenderFns } from "./CreatePart1.vue?vue&type=template&id=23953d22&"
import script from "./CreatePart1.vue?vue&type=script&lang=js&"
export * from "./CreatePart1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports